const tableSchemaBase = [
	{
		accessor: 'site',
		title: 'global.site',
		defaultVisible: true,
		fixed: true,
		footerType: 'sumSitesProductions',
	},
	{
		accessor: 'startDate',
		title: 'global.startDate',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'quantityConverted',
		title: 'global.quantity',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'tokenEquivalent',
		title: 'global.tokenEquivalent',
		defaultVisible: true,
		fixed: true,
	},
	{
		type: 'showDeleteAction',
		accessor: '',
		title: null,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
